export default "__VITE_ASSET__b13a0927__"